module.exports = new __parcel__URL__("periscope-page-stable.tpl.2b13b8d4.svg").toString();